import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { formatMilisecondsAdaptive } from '../../../utils/dateUtils';

type Values = Record<string, string | number>;

const useMtText = () => {
    const intl = useIntl();

    const t = useCallback(
        (key: string, values?: Values) => intl.formatMessage({ id: `intl-msg:maintenanceTracking.${key}` }, values),
        [intl]
    );

    const msg = useCallback(
        (id: string | undefined, values?: Values) => (id ? intl.formatMessage({ id }, values) : ''),
        [intl]
    );

    const formatNumber = useCallback((value: number) => value.toLocaleString(intl.locale), [intl.locale]);

    const formatDuration = useCallback(
        (ms?: number) => (ms === undefined || Number.isNaN(ms) ? '–' : formatMilisecondsAdaptive(ms, intl.locale)),
        [intl.locale]
    );

    const formatDateTime = useCallback(
        (value?: Date | string | null) => {
            if (!value) {
                return '–';
            }
            const date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return '–';
            }
            return `${date.toLocaleDateString(intl.locale, { day: '2-digit', month: '2-digit' })} ${date.toLocaleTimeString(
                intl.locale,
                { hour: '2-digit', minute: '2-digit' }
            )}`;
        },
        [intl.locale]
    );

    return { t, msg, formatNumber, formatDuration, formatDateTime };
};

export default useMtText;
